import "./Skills.scss";
const img1 =
  "https://images.unsplash.com/photo-1505685509042-16b1b75030cf?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80";
const list = [
  "Learn new recepies",
  "Experiment with food",
  "write nutrition facts",
  "Know nutrition tips",
  "Get cooking tips",
  "Get ranked",
];

function Skills() {
  return (
    <div className="section skills">
      <div className="col img">
        <img src={img1} alt="" />
      </div>
      <div className="col typography">
        <h1 className="title">Improve Your Culinary Skills</h1>
        {list.map((item, index) => (
          <p className="skill-item" key={index}>
            {item}
          </p>
        ))}
        <button className="skills-btn">SIGNUP NOW</button>
      </div>
    </div>
  );
}

export default Skills;
